<template>
  <footer class="vz-footer">
    <div class="vz-footer-content">
      <div class="vz-footer-section vz-footer-logo">
        <nuxt-link class="vz-logo" to="/" aria-label="Início">
          <strong>{{ $store.state.config.title || 'Vizzto' }} </strong>
        </nuxt-link>
      </div>
      <section class="vz-footer-section">
      </section>
      <div style="display: flex; gap: 10px">
        <div v-if="terms?.privacyPolicy" class="terms-link" @click="openTerms('PRIVACY_POLICY')">Políticas de Privacidade</div>
        <div v-if="terms?.termsOfUse" class="terms-link" @click="openTerms('TERMS_OF_USE')">Termos de uso</div>
      </div>
    </div>
  </footer>
</template>

<script>
import VzLink from 'vsp-web-ui-lib/components/atoms/vz-link.vue';
import DeviceStorage from '../../libs/device-storage';

export default {
  name: 'Footer',
  data() {
    return {
      terms: {
        privacyPolicy: false,
        termsOfUse: true,
      }
    }
  },
  components: {
    VzLink
  },
  props: {
    sections: {
      type: Array,
      default: () => []
    }
  },
  mounted() {
    const distributor = DeviceStorage.get('distributor');
    this.terms.privacyPolicy = distributor.hasPrivacyPolicy;
    this.terms.termsOfUse = distributor.hasTermsOfUse;
  },
  methods: {
    openTerms(type) {
      this.$store.dispatch('terms/openTerms', type);
    }
  }
};
</script>

<style theme="dark-theater" scoped>
.terms-link {
  cursor: pointer;
}
.vz-footer {
  width: 100%;
  background-color: #070707;
  font-size: 0.874em;
}

.vz-footer-content {
  padding: 32px 32px;
  width: 100%;
}

.vz-logo {
  display: inline-block;
  width: 180px;
  height: 40px;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: contain;
  background-image: var(--logo-footer-bar);
  border-bottom-width: 0;
}

.vz-logo strong {
  display: none;
}

.vz-section-title {
  display: none;
  border-bottom-width: 0;
}

.vz-footer-link {
  color: #bebebe;
  border-bottom-width: 0;
  display: block;
}

.vz-footer-link:hover {
  color: var(--link-color-over);
}

.vz-footer-link:active {
  color: var(--link-color-active);
}

.vz-footer-link-ic {
  display: none;
}

.vz-footer-link[href*='facebook.com'] .vz-footer-link-ic,
.vz-footer-link[href*='twitter.com'] .vz-footer-link-ic,
.vz-footer-link[href*='instagram.com'] .vz-footer-link-ic,
.vz-footer-link[href*='youtube.com'] .vz-footer-link-ic,
.vz-footer-link[href*='maps.google.com'] .vz-footer-link-ic,
.vz-footer-link[href^='mailto:'] .vz-footer-link-ic,
.vz-footer-link[href^='tel:'] .vz-footer-link-ic {
  display: inline-block;
  vertical-align: middle;
  font-size: 16px;
  margin-right: 8px;
}

.vz-footer-link[href*='facebook.com'] .vz-footer-link-ic,
.vz-footer-link[href*='twitter.com'] .vz-footer-link-ic,
.vz-footer-link[href*='instagram.com'] .vz-footer-link-ic,
.vz-footer-link[href*='youtube.com'] .vz-footer-link-ic {
  color: #ffffff;
}

.vz-footer-link[href*='maps.google.com'] .vz-footer-link-ic,
.vz-footer-link[href^='mailto:'] .vz-footer-link-ic,
.vz-footer-link[href^='tel:'] .vz-footer-link-ic {
  color: #40393a;
}

.vz-footer-link[href*='facebook.com'] .vz-footer-link-ic:before {
  content: '\e938';
}

.vz-footer-link[href*='twitter.com'] .vz-footer-link-ic:before {
  content: '\e99a';
}

.vz-footer-link[href*='instagram.com'] .vz-footer-link-ic:before {
  content: '\e94a';
}

.vz-footer-link[href*='youtube.com'] .vz-footer-link-ic:before {
  content: '\e9ac';
}

.vz-footer-link[href*='maps.google.com'] .vz-footer-link-ic:before {
  content: '\e955';
}

.vz-footer-link[href^='mailto:'] .vz-footer-link-ic:before {
  content: '\e954';
}

.vz-footer-link[href^='tel:'] .vz-footer-link-ic:before {
  content: '\e986';
}

.vz-footer-section {
  margin-top: 32px;
}

.vz-footer-section ul {
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.vz-footer-section li {
  list-style: none;
}

.vz-footer-logo {
  text-align: center;
  margin: 0 0 32px;
}

@media (min-width: 1024px) {
  .vz-footer-content {
    margin: 0;
    padding: 24px 48px;
    display: grid;
    grid-template-columns: 23.8% 23.8% 1fr;
    row-gap: 48px;
    align-items: end;
  }

  .vz-footer-logo {
    margin: 0;
    text-align: left;
  }

  .vz-logo {
    background-position: left center;
  }

  .vz-footer-section {
    margin: 0;
  }

  .vz-footer-section:nth-child(2),
  .vz-footer-section:nth-child(4) {
    grid-column-start: 3;
  }

  .vz-footer-section:nth-child(2) li {
    display: inline-block;
    margin-left: 32px;
  }

  .vz-footer-section:nth-child(4) {
    margin-left: 32px;
  }
}
</style>







































































































































































